<template>
    <div class="game-servers-management-container">
      <div class="game-servers-options-container">
        <h1 class="gsoc-heading content-header">Miscellaneous Config Options</h1>
      </div>
  
  
      <div class="gsoc-content">
        <button
          class="gsoc-button"
          @click="openModal"
          :disabled="!this.originalConfig"
          
        >
          Miscellaneous Config
        </button>
        
      </div> 
      <Modal :show="showModal" @update:show="showModal = $event">
        <template v-slot:header-content>
          <div class="header-content-container">
            <p class="modal-sub-heading">Miscellaneous</p>
            <p class="modal-main-heading">Edit Configuration</p>
          </div>
        </template>
        <template v-slot:body-content>
          <div class="modal-body-content-container">
    
  
            <form class="modal-body-cc-inner" >
              <div class="config-row">
                <div class="config-option">
                  <label for="allow_bounties">Default Economy Balance</label>
                  <input
                    name=""
                    id=""
                    class="config-option-input"
                    v-model="
                      updatedConfig.default_user_balance
                    "
                    type="number"
                    min="0"

                  >
                </div>
                <div class="config-option">
                  <label for="minimum_bounty_amount">Force Online Linking</label>
                    <select
                        name=""
                        class="config-option-dropdown"
                        v-model="updatedConfig.force_online_link"
                    >
                        <option value="true">True</option>
                        <option value="false">False</option>
                    </select>
                </div>
              </div>
  
              <div class="config-row">
                <div class="config-option">
                  <label for="maximum_bounty_amount">Max Linked Accounts</label>
                  <input
                    name=""
                    class="config-option-input"
                    v-model="
                        updatedConfig.max_account_link_per_user
                    "
                    type="number"
                    min="0"
                    max="1000000"
                  />
                </div>
                <div class="config-option">
                  <label for="role_on_link">
                    Role On Link
                  </label>
                  <select
                    name=""
                    class="config-option-dropdown"
                    v-model="updatedConfig.role_id_on_link"
                  >
                  <option value="">None</option>
                    <option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                    >
                      {{ role.name }}
                    </option>
  
                  </select>
  
                </div>
              </div>
             
            </form>
  
          </div>
        </template>
        <template v-slot:footer-content>
          
  
          <div
            class="modal-footer-content-container"
          
          >
            <button
              class="modal-btn cancel-btn"
              @click="cancelChanges()"
            >
              Cancel Changes
            </button>
            <button
              :disabled="!allowSubmitChanges"
              class="modal-btn save-btn"
              @click="submitConfigChanges()"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p class="btn-text">Save Changes</p>
            </button>
          </div>
  
        
        </template>
      </Modal>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import axios from 'axios';
  import Modal from './Modal.vue';
  import { validatePagePermissions } from '../utils/permissions';
  export default {
    components: {
      Modal,
    },
    data() {
      return {
        showModal: false,
        originalConfig: {},
        updatedConfig: {},
        roles: [],
        allowSubmitChanges: true,
      };
    },

    methods: {
        getChangedKeyValuePairs(changdObject, originalObject) {

            let changedValues = {};
            for (let key in changdObject) {
            if (changdObject[key] !== originalObject[key]) {
                changedValues[key] = changdObject[key];
            }
            }
            return changedValues;
            },
        async openModal() {
            await this.getGuildChannelsAndRoles()
            this.showModal = true
        },
        cancelChanges() {
            this.updatedConfig = JSON.parse(JSON.stringify(this.originalConfig))
            this.showModal = false
        },
        async submitConfigChanges() {
            let changedValues = this.getChangedKeyValuePairs(this.updatedConfig, this.originalConfig)
            if (Object.keys(changedValues).length === 0) {
                this.showModal = false
                return
            }


            const response = await this.$store.dispatch('sendRequest', {
                method: 'PUT',
                url: `${this.$store.state.apiUrl}/api/configuration/misc_config`,
                data: {
                    ...changedValues
                },
                show_message_on_success: true,
            });

            if (!response) {
                return;
            }

            let updated = response.updated_config
            this.originalConfig = JSON.parse(JSON.stringify(updated))
            this.updatedConfig = JSON.parse(JSON.stringify(updated))
            let websocketMessage = {
                event: 'updatingCache',
                action: 'setMiscellaneousConfig',
                discord_server_id: this.$store.state.client_discord_server_id,
                data: updated,
            };

            this.$store.state.websocket.send(JSON.stringify(websocketMessage));

            
            this.showModal = false
        },
        async getMiscellaneousConfig() {

            let currentCacheTimestamp = this.$store.state.cachedMiscellaneousConfig.last_cache_timestamp

            if (currentCacheTimestamp) {
                let currentTime = new Date()
                let timeDifference = currentTime - currentCacheTimestamp
                let minutesDifference = Math.floor(timeDifference / 60000)
                if (minutesDifference < 10) {
                    return this.$store.state.cachedMiscellaneousConfig
                }
            }

            
            const response = await this.$store.dispatch('sendRequest', {
            method: 'GET',
            url: `${this.$store.state.apiUrl}/api/configuration/misc_config`,
            show_message_on_success: false,
            });

            if (!response) {
                return null
            }

            let config = response.misc_config
            let websocketMessage = {
            event: 'updatingCache',
            action: 'setMiscellaneousConfig',
            discord_server_id: this.$store.state.client_discord_server_id,
            data: config,
            };

            this.$store.state.websocket.send(JSON.stringify(websocketMessage));

            return config

            

        
            
        },
        async getGuildChannelsAndRoles() {
        const response = await this.$store.dispatch('sendRequest', {
            url: `${this.$store.state.apiUrl}/api/dashboard/discord/guilds/roles-channels-users`,
            params: {
            guild_id: this.$store.state.client_discord_server_id,
            },
            show_message_on_success: false
        });

        if (!response) {
            return;
        }

        this.roles = [
            ...response.roles
            .filter(role => role.name !== '@everyone') // Exclude the '@everyone' role
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(role => ({
                ...role,
                type: 'role',
                selected: false,
            }))
        ];
},
    },
    async created() {
        let config = await this.getMiscellaneousConfig()
        if (config) {
            this.originalConfig = config
            this.updatedConfig = JSON.parse(JSON.stringify(config))
        } else {
            // dont render the component, show error message

        }
  
    },

  
  
  
  };
  </script>
  
  <style scoped>
  .game-servers-management-container {
    background: rgba(187, 218, 255, 0.04);
    border: 1px solid rgba(187, 218, 255, 0.08);
    border-radius: 16px;
    width: 100%;
    display: flex;
    padding: 24px;
    flex-direction: column;
    row-gap: 24px;
  }
  
  .choose-gameserver-dropdown {
    /* Frame 171 */
  
    box-sizing: border-box;
  
    display: inline-block;
    padding: 12px 16px;
    gap: 16px;
  
    max-width: 200px;
    height: 45px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    width: 100%;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
    appearance: none; /* Remove default arrow */
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M12.6666 6.5L7.99992 11.1667L3.33325 6.5" stroke="white" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center; /* Position it 16px from the right edge */
    padding-right: 36px; /* Add padding to prevent the text from overlapping the arrow */
    cursor: pointer;
    background-color: rgba(195, 218, 252, 0.08);
  }
  
  .choose-gameserver-dropdown:focus {
    outline: none;
  }
  
  .choose-gameserver-dropdown option {
    color: black;
  }
  
  .gsoc-heading {
    text-align: left;
    margin: 0;
  }
  
  .gsoc-content {
    display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 200px));
      align-items: center;
      color: white;
      column-gap: 20px;
      row-gap: 10px;
  }
  
  .server-options-sub-heading {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 150%;
    /* identical to box height, or 24px */
    text-align: left;
    color: #ffffff;
  }
  
  .gsoc-button {
    display: flex;
    padding: 12px 16px;
  
    max-width: 200px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    background-color: rgba(195, 218, 252, 0.08);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 150%;
    /* identical to box height, or 24px */
    text-align: left;
    color: #ffffff;
    cursor: pointer;
  }
  
  .modal-sub-heading {
    /* COMMAND NAME */
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 15px;
    /* identical to box height */
    letter-spacing: 0.08em;
  
    color: #bbced8;
  }
  .modal-main-heading {
    /* Add Channels */
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 29px;
    /* identical to box height */
  
    color: #ffffff;
  
    margin-top: 8px;
  }
  
  /* Frame 171 */
  
  .config-option-dropdown {
    box-sizing: border-box;
  
    display: inline-block;
  
    padding: 8px 12px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
    appearance: none; /* Remove default arrow */
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M12.6666 6.5L7.99992 11.1667L3.33325 6.5" stroke="white" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    background-repeat: no-repeat;
    background-position: right 16px center; /* Position it 16px from the right edge */
    padding-right: 36px; /* Add padding to prevent the text from overlapping the arrow */
    cursor: pointer;
    background-color: rgba(195, 218, 252, 0.08);
  }
  
  .config-option-input,
  .config-option-dropdown {
    width: 165px;
  }
  .config-option-input {
    background-color: rgba(195, 218, 252, 0.08);
    box-sizing: border-box;
  
    display: inline-block;
  
    padding: 8px 12px;
  
    border: 1px solid rgba(195, 238, 252, 0.16);
    border-radius: 12px;
  
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 150%;
    /* identical to box height, or 21px */
  
    color: #ffffff;
  }
  .config-option-dropdown:focus,
  .config-option-input:focus {
    outline: none;
  }
  
  .config-option-dropdown option,
  .config-option-input option {
    color: black;
  }
  
  .modal-body-cc-inner {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }
  .config-row {
    display: flex;
    justify-content: space-between;
  }
  
  .config-option {
    flex-direction: column;
    text-align: left;
    display: flex;
    row-gap: 4px;
  }
  
  .config-option label {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 15px;
    /* identical to box height */
    /* letter-spacing: 0.08em; */
    padding-left: 5px;
  
    color: #bbced8;
  }
  
  /* for screens below 700px */
  @media (max-width: 800px) {
    
  }
  
  </style>
  